module.exports = __webpack_public_path__ + "catalog/items/corner-shower/corner-shower.svg";